"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHull = exports.concaveHull = void 0;
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const ConvexHull_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/ConvexHull.js"));
const ltpoint_1 = require("./ltpoint");
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const ltentity_1 = require("./ltentity");
function concaveHull(points) {
    let temp_points = [];
    for (let i = 0; i < points.length; i++) {
        temp_points.push([points[i].x, points[i].y]);
    }
    let concave_points = window.hull(temp_points, 0);
    let result_points = [];
    for (let i = 0; i < concave_points.length; i++) {
        result_points.push(new ltpoint_1.LTPoint(concave_points[i][0], concave_points[i][1]));
    }
    return new ltentity_1.LTPolyline(result_points);
}
exports.concaveHull = concaveHull;
//求凸包
function convertHull(points) {
    let factory = new GeometryFactory_js_1.default();
    let arr = new Array();
    for (let point of points) {
        arr.push(new Coordinate_js_1.default(point.x, point.y));
    }
    let lineString = factory.createLineString(arr);
    let convexHull = new ConvexHull_js_1.default(lineString);
    let polygon_hull = convexHull.getConvexHull();
    if (polygon_hull.getGeometryType() === "Polygon") {
        const shell = polygon_hull.getExteriorRing();
        let points_shell = shell.getCoordinates();
        let result_points = [];
        for (let i = 0; i < points_shell.length; i++) {
            result_points.push(new ltpoint_1.LTPoint(points_shell[i].x, points_shell[i].y));
        }
        return new ltentity_1.LTPolyline(points);
    }
    else {
        let points_shell = polygon_hull.getCoordinates();
        let result_points = [];
        for (let i = 0; i < points_shell.length; i++) {
            result_points.push(new ltpoint_1.LTPoint(points_shell[i].x, points_shell[i].y));
        }
        return new ltentity_1.LTPolyline(points);
    }
}
exports.convertHull = convertHull;
